import request from "root/js/request";

export const getAnalyticsCrossMPOrders = async ({ cabinet_id__in, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/orders/",
    method: "get",
    params: {
      cabinet_id__in,
      ...rest,
    },
  });
  return response.data;
};
